/**
 * Top-level reducer for the redux store.
 */
import {TypedUseSelectorHook, useSelector} from 'react-redux';
import {createSelector, createStructuredSelector} from 'reselect';

import combineBenchlingReducers from 'util/combineBenchlingReducers';

import reduceModels, {ModelsState} from './reduceModels';
import reduceUI, {UIState} from './reduceUI';

export interface BenchlingState {
  models: ModelsState;
  ui: UIState;
}

export default combineBenchlingReducers({
  models: reduceModels,
  ui: reduceUI,
});

export type SelectorFunction<T> = (state: BenchlingState) => T;
export const useAppSelector: TypedUseSelectorHook<BenchlingState> = useSelector;
export const createAppSelector = createSelector.withTypes<BenchlingState>();
export const createAppStructuredSelector = createStructuredSelector.withTypes<BenchlingState>();
